(function(){
var EMAIL='info@stoneatelierbyskl.com';
var OLD_EMAIL='stoneatelierbyskl@gmail.com';
var WA='971507594079';
var MAP={"Sandstone":["Grey","Black","Beige","Off White"],"Marble":["Indian Black Marble","Indian White Marble","Mocha Limestone","Travertine","Indian Carrara Marble","Indian Grey Marble","Indian Panda Marble","River Blue Marble","Forest Green Marble"],"Imported Marble":["Marquina Black Marble","Vietnam White Marble","Bottocino Beige"],"Granite":["Black Granite"]};

(function(){
  var s=document.currentScript||(function(){var a=document.getElementsByTagName('script');return a[a.length-1];})();
  var base=(s&&s.src)?s.src.replace(/stone-swatches\.js.*$/,''):'';
  var l=document.createElement('link');
  l.rel='stylesheet';
  l.href=base+'stone-actions.css';
  document.head.appendChild(l);
  function addScript(id,file){
    if(document.getElementById(id))return;
    var b=document.createElement('script');
    b.id=id;b.src=base+file;b.defer=true;
    document.head.appendChild(b);
  }
  addScript('sa-buy-js','stone-buy.js');
  addScript('sa-mat-js','stone-materials.js');
})();

function fixLegacyEmail(){
  var links=document.querySelectorAll('a[href*="'+OLD_EMAIL+'"]');
  for(var i=0;i<links.length;i++){
    links[i].setAttribute('href',links[i].getAttribute('href').split(OLD_EMAIL).join(EMAIL));
  }
}

function picker(){return document.querySelector('variant-picker[data-block-id$="variant_picker_R3rGDr"]')||document.querySelector('variant-picker');}

function paint(){
  var p=picker(); if(!p)return;
  var mat=p.querySelector('input[data-option-name="Material"]:checked');
  if(!mat)return;
  var allowed=MAP[mat.value]||[];
  var inputs=p.querySelectorAll('input[data-option-name="Colour"]');
  var firstAllowed=null,checkedOk=false;
  for(var i=0;i<inputs.length;i++){
    var inp=inputs[i];var lbl=inp.closest('.variant-option__button-label');if(!lbl)continue;
    var ok=allowed.indexOf(inp.value)>-1;
    if(lbl.classList.contains('vp-hide')===ok)lbl.classList.toggle('vp-hide',!ok);
    if(ok){if(!firstAllowed)firstAllowed=inp;if(inp.checked)checkedOk=true;}
  }
  if(!checkedOk&&firstAllowed){firstAllowed.click();}
}

function productTitle(){
  var h=document.querySelector('.product-details h1')||document.querySelector('main h1')||document.querySelector('h1');
  return h?h.textContent.replace(/\s+/g,' ').trim():'';
}

function selectionText(){
  var p=picker(); if(!p)return '';
  var chosen={};
  var inputs=p.querySelectorAll('input:checked');
  for(var i=0;i<inputs.length;i++){
    var el=inputs[i];
    var lbl=el.closest('.variant-option__button-label');
    if(lbl&&lbl.classList.contains('vp-hide'))continue;
    var n=el.getAttribute('data-option-name')||'';
    var v=(el.value||'').trim();
    if(n&&v)chosen[n]=v;
  }
  var parts=[];
  if(chosen['Colour'])parts.push(chosen['Colour']);
  else if(chosen['Material'])parts.push(chosen['Material']);
  if(chosen['Finish'])parts.push(chosen['Finish'].toLowerCase()+' finish');
  for(var k in chosen){if(k!=='Colour'&&k!=='Material'&&k!=='Finish'&&chosen[k])parts.push(chosen[k]);}
  return parts.length?' in '+parts.join(', '):'';
}

function refreshLinks(){
  var wrap=document.querySelector('.stone-actions'); if(!wrap)return;
  var links=wrap.querySelectorAll('a.stone-actions__btn'); if(!links.length)return;
  var title=productTitle(); if(!title)return;
  var sel=selectionText();
  var custText='Hi Stone Atelier by SKL, I would like to customise the '+title+sel+'. Could you help me with sizing, stone options and a quotation?';
  var consultText='Hi, I am interested in the '+title+sel+' and would like a consultation.';
  var custHref='https://wa.me/'+WA+'?text='+encodeURIComponent(custText);
  var consultHref='https://wa.me/'+WA+'?text='+encodeURIComponent(consultText);
  for(var i=0;i<links.length;i++){
    var a=links[i];var h=a.getAttribute('href')||'';
    var isQuote=(h.indexOf('mailto:')===0)||/request\s*(a\s*)?(quote|customisation|customization)/i.test(a.textContent||'');
    if(isQuote){
      if(h!==custHref)a.setAttribute('href',custHref);
      a.setAttribute('target','_blank');
      a.setAttribute('rel','noopener');
      if((a.textContent||'').trim()!=='Request Customisation')a.textContent='Request Customisation';
    } else if(h.indexOf('wa.me')>-1){
      if(h!==consultHref)a.setAttribute('href',consultHref);
    }
  }
}

function cycle(){paint();refreshLinks();fixLegacyEmail();}
function burst(){cycle();setTimeout(cycle,120);setTimeout(cycle,350);setTimeout(cycle,700);setTimeout(cycle,1200);}

function boot(){
  burst();
  document.addEventListener('change',function(e){
    if(e.target&&e.target.closest&&e.target.closest('variant-picker'))burst();
  },true);
  document.addEventListener('click',function(e){
    if(e.target&&e.target.closest&&e.target.closest('variant-picker'))burst();
  },true);
  var mo=new MutationObserver(function(){cycle();});
  mo.observe(document.body,{childList:true,subtree:true});
  setInterval(cycle,1500);
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();